export const actionTypes = {
  SYSTEM_ADMIN_DETAIL_REQUEST: 'SYSTEM_ADMIN_DETAIL_REQUEST',
  SYSTEM_ADMIN_DETAIL_SUCCESS: 'SYSTEM_ADMIN_DETAIL_SUCCESS',
  SYSTEM_ADMIN_DETAIL_FAILURE: 'SYSTEM_ADMIN_DETAIL_FAILURE',
  UPDTAE_SYSTEM_ADMIN_STATUS_REQUEST: 'UPDTAE_SYSTEM_ADMIN_STATUS_REQUEST',
  UPDTAE_SYSTEM_ADMIN_STATUS_SUCCESS: 'UPDTAE_SYSTEM_ADMIN_STATUS_SUCCESS',
  UPDTAE_SYSTEM_ADMIN_STATUS_FAILURE: 'UPDTAE_SYSTEM_ADMIN_STATUS_FAILURE',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
};
